module.exports = {
      id: "icon-open-in-new-usage",
      viewBox: "0 0 24.047 24.047",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#icon-open-in-new",
      toString: function () {
        return this.url;
      }
    }